/**
 * Mejora progresiva de los chips de color de la tarjeta (card-color-swatches +
 * card-color-gallery). El cambio de foto al hacer clic ya funciona sólo con CSS
 * (radios + `:checked`); este script únicamente:
 *   1. Mueve el anillo "activo" al chip del color elegido.
 *   2. Sincroniza el enlace principal de la tarjeta con la variante del color
 *      (para que un clic en cualquier parte de la tarjeta lleve a ese color).
 *
 * Es un único listener delegado en el documento: no añade nada por tarjeta.
 */
document.addEventListener('change', (event) => {
  const radio = event.target;
  if (!(radio instanceof HTMLInputElement) || !radio.classList.contains('cpair__radio')) return;
  if (!radio.checked) return;

  const card = radio.closest('product-card, .product-card');
  if (!card) return;

  // 1) Mover el anillo activo al chip correspondiente.
  const chips = card.querySelectorAll('.card-color-swatches__chip');
  chips.forEach((chip) => chip.classList.remove('card-color-swatches__chip--active'));
  const activeChip = card.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
  activeChip?.classList.add('card-color-swatches__chip--active');

  // 2) Sincronizar con la URL del color: el enlace principal de la tarjeta,
  //    el del título y cualquier otro enlace marcado (foto). Así un clic en
  //    cualquier parte de la tarjeta lleva al color elegido.
  const url = radio.dataset.url;
  if (url) {
    const links = card.querySelectorAll('a.product-card__link, a[ref="productTitleLink"]');
    links.forEach((link) => {
      if (link instanceof HTMLAnchorElement) link.href = url;
    });
  }
});
